{
  "name": "facturation-app-regie",
  "description": "Gestion de la régie",
  "version": "0.9.9-alpha.1",
  "license": "SEE LICENSE IN LICENSE.md",
  "main": "lib/js/index.js",
  "module": "lib/es/index.js",
  "types": "lib/ts/index.d.js",
  "scripts": {
    "lint": "biome check .",
    "lint:fix": "biome check --write .",
    "test": "bun run test:unit",
    "test:unit": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:update": "vitest run -u",
    "test:all": "vitest run -u --coverage",
    "start": "NODE_ENV=development vite dev",
    "start:nocache": "NODE_ENV=development vite dev --force",
    "build": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
    "build:app": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
    "release:beta": "bun pm version prerelease --preid=alpha && git push --follow-tags",
    "bump:patch": "bun pm version patch --no-git-tag-version && git commit -m v$(node -pe \"require('./package.json').version\") package.json && git push",
    "bump:minor": "bun pm version minor --no-git-tag-version && git commit -m v$(node -pe \"require('./package.json').version\") package.json && git push",
    "tag": "git push && git tag v$(node -pe \"require('./package.json').version\") && git push origin v$(node -pe \"require('./package.json').version\")"
  },
  "engines": {
    "node": ">=22"
  },
  "dependencies": {
    "@mairistem/adresses": "^0.7.1",
    "@mairistem/composants": "0.9.0",
    "@mairistem/fiche": "^0.11.6",
    "@mairistem/liste": "^0.11.4",
    "@mairistem/module": "^0.10.4",
    "@mairistem/tools": "^0.4.9",
    "@redux-devtools/extension": "^3.3.0",
    "@sentry/react": "^10.53.1",
    "@sentry/vite-plugin": "^5.3.0",
    "classnames": "^2.5.1",
    "dayjs": "^1.11.20",
    "lodash": "^4.18.1",
    "quill": "^2.0.3",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-router": "^5.3.4",
    "react-router-dom": "^5.3.4",
    "react-toastify": "^11.1.0",
    "zustand": "^5.0.13"
  },
  "overrides": {
    "@mairistem/tools": "^0.4.9"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.15",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.4.3",
    "@types/lodash": "^4.17.24",
    "@types/node": "^22.19.19",
    "@types/react": "^18.3.28",
    "@types/react-dom": "^18.0.6",
    "@types/react-router": "^5.1.18",
    "@types/react-router-dom": "^5.3.3",
    "@vitejs/plugin-react": "^6.0.2",
    "@vitest/coverage-istanbul": "^4.1.6",
    "buffer": "^6.0.3",
    "crypto-browserify": "^3.12.1",
    "happy-dom": "^20.9.0",
    "path-browserify": "^1.0.1",
    "stream-browserify": "^3.0.0",
    "terser": "^5.47.1",
    "typescript": "~6.0.0",
    "vite": "^8.0.13",
    "vitest": "^4.1.6"
  }
}
